let Draw = {

    get: function (id) {
        Api.get('/draws/list', {surveyId: id}, function (r) {
            if (r.success) {

                $('#drawDetails').append(
                    `
                        <div><strong>Sorteo</strong> # ${r.data.draw.id}</div>
                        <div><strong>Identificador único</strong>: ${r.data.draw.uniqueId}</div>
                        <div><strong>Total de participantes</strong>: ${r.data.draw.totalParticipants}</div>
                        <div><strong>Fecha del sorteo</strong>: ${Time.getHTML(r.data.draw.created_at)}</div>
                    `
                );

                if (r.data.winners.length>0) {
                    for (var i = 0; i < r.data.winners.length; i++) {
                        $('#containerWinners').append(
                            `<div class="account-box">
	                    	<div class="avatar" style="background-image:url(${r.data.winners[i].user.avatar});">
	                    		<a href="/${r.data.winners[i].user.username}"></a>
	                    	</div>
	                    	<div class="body">
	                        	<span>
	                        	    <h1><a href="/${r.data.winners[i].user.username}">${r.data.winners[i].user.name}</a></h1> <i>${r.data.winners[i].user.nick}</i>
	                        	</span>
	                    	</div>
	                    	<div class="button orange right" rel="tooltip" data-name="${r.data.winners[i].position} lugar"  style="margin:11px;"><span class="glyphicons glyphicons-cup"></span>${(r.data.winners[i].position>0) ? r.data.winners[i].position : 'N/A'}</div>
	                	</div>
						`
                        );
                    }
                }
            }

        });
    }

};
